import React, { Component } from 'react';
import ApplicationsPage from '../../../Modules/Pages/Applicant/ApplicationsPage/ApplicationsPage';
import LoginPage from '../../../Modules/Pages/LoginPage/LoginPage.js'
import { MAIN_CONFIG } from '../../../config/main';
import Custom404Page from '../../404.js';
const { USER_CONTEXT } = MAIN_CONFIG;


export default class ApplyContainer extends Component {

    static async getInitialProps(context) {
        return ApplicationsPage.getInitialProps(context, MAIN_CONFIG.PAGE_TYPES.APPLICANT.APPLY);
    }

    render() {
        const { userContext } = this.props;

        switch (userContext) {
            case USER_CONTEXT.APPLICANT:
            case USER_CONTEXT.TEAMMEMBER:
            case USER_CONTEXT.LOGGED_OUT:
                return <ApplicationsPage { ...this.props } />; //<LoginPage { ...this.props } />;
            default:
                return <Custom404Page {...this.props} message="Page not found, Please check your page URL and retry." />
        }
    }
}

